<template>
  <div class="invitationJoin">
    <div class="bg"></div>
    <div class="bgf">
      <div class="personLogo">
        <img src="../../assets/images/publicImg/touxiang_default.png" v-if="!detailData.headImg">
        <img :src="detailData.headImg" v-else @click.stop="imagePreview(detailData.headImg)">
      </div>
      <div class="companyName">{{ detailData.name }}</div>
      <div class="tagBox">
        <span class="is-auth-tag" v-show="detailData.isAuth === 1">已实名</span>
        <span v-show="detailData.isAuth === 0" class="weiShiMing">未实名</span>
        <span v-show="detailData.type == 0">个人</span>
        <span v-show="detailData.type == 1">班组</span>
        <span v-show="detailData.type == 2">企业</span>
      </div>
      <div v-for="(item, index) in detailData.datas" :key="index" v-if="item.id !== 'score'">
        <span class="headTitle">{{ item.key }}</span>
        <span class="text">{{ item.value }}</span>
      </div>
      <div v-for="(val, index) in detailData.datas" :key="index" v-if="val.id == 'score'">
        <span class="headTitle">{{ val.key }}</span>
        <span class="text" v-if="val.value.socreLevel == -1">黑名单</span>
        <span class="text" v-if="val.value.socreLevel == 0">信用未评级</span>
        <img src="../../assets/images/distribution/star_one.png" class="star_one" v-if="val.value.starCount === 1">
        <img src="../../assets/images/distribution/star_two.png" class="star_two" v-if="val.value.starCount === 2">
        <img src="../../assets/images/distribution/star_three.png" class="star_three" v-if="val.value.starCount === 3">
        <img src="../../assets/images/distribution/star_four.png" class="star_four" v-if="val.value.starCount === 4">
        <img src="../../assets/images/distribution/star_five.png" class="star_five" v-if="val.value.starCount === 5">
      </div>
    </div>

    <div class="bottom-btn">
      <van-button class="van-button-1" color="#E83B3BFF" round @click="refuseSigned" plain block>拒绝</van-button>
      <van-button class="van-button-2" color="#096CEFFF" round @click="signed" block>同意</van-button>
    </div>

    <imagePopup v-model="showImagePopup" :imgUrl="imgUrl"/>
  </div>
</template>

<script>
import { getCompanyDetail, refuseInvite, agreeInvite } from '@api/news'
import imagePopup from '@components/imagePopup/imagePopup'

export default {
  name: 'invitationJoin',
  components: {
    imagePopup
  },
  data () {
    return {
      detailData: {},
      showImagePopup: false,
      imgUrl: ''
    }
  },
  created () {
    this.getCompanyDetail()
  },
  methods: {

    // 下载附件
    attachsDetail (attachUrl) {
      this.$bridge.callHandler('newPage', { url: attachUrl }, response => {
        console.log('response:', response)
      })
    },

    getCompanyDetail () {
      getCompanyDetail({
        id: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    refuseSigned () {
      refuseInvite({
        id: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('拒绝成功')
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    signed () {
      agreeInvite({
        id: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('操作成功')
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    },
    // 添加好友
    addFriends () {
      const data = { imId: this.detailData.id }
      this.$bridge.callHandler('addFriends', data, response => {
        console.log('response:', response)
      })
    },
    // 发消息
    sendMessage () {
      const data = {
        imId: this.detailData.id,
        name: this.detailData.name
      }
      this.$bridge.callHandler('sendMessage', data, response => {
        console.log('response:', response)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.van-button--default{
  background-color: #FFFFFF;
}

.invitationJoin {
  .companyListStyle {
    max-height: 70vh;
    overflow-y: scroll;
    padding-top: 20px;

    .invitedTitle {
      @include add_size($font_size_20);
      color: #333;
      font-weight: bold;
      text-align: center;
      margin-bottom: 25px;
    }
  }

  .bg {
    width: 100%;
    height: 68px;
    background: #096CEF;
  }

  .bgf {
    background: #fff;
    padding: 8px 12px 12px;
    position: relative;
  }

  .personLogo {
    margin-top: -48px;

    img {
      border-radius: 5px;
      width: 80px;
      height: 80px;
    }
  }

  .tagBox {
    span {
      display: inline-block;
      @include add_size($font_size_13);
      color: #096CEF;
      min-height: 20px;
      padding: 0 5px;
      text-align: center;
      background: rgba(9, 108, 239, 0.07);
      margin-right: 8px;
      border-radius: 2px;
      border: 1px solid #8DBEFE;

      &:last-child {
        margin-right: 0;
      }
    }

    .weiShiMing {
      background: rgba(204, 204, 204, 0.07);
      border: 1px solid #ccc;
      color: #CCCCCC;
    }
  }

  .headTitle {
    @include add_size($font_size_15);
    color: #999999;
    margin-right: 8px;
  }

  .text {
    @include add_size($font_size_15);
    color: #333333;
  }

  .star_one {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_two {
    width: 40px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_three {
    width: 60px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_four {
    width: 80px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_five {
    width: 100px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .companyName {
    margin-top: 12px;
    @include add_size($font_size_18);
    font-weight: 600;
  }
}
</style>
